export const phoneNumbers = [
    '01143433875',
    '01097950005'
]
export const whatsappNumbers = [
    '01143433875',
    '01097950005'
]